import { Injectable } from '@angular/core';
import { observable } from 'mobx-angular';

import { TableViewAdministrationState } from '../../common/enum/table-view-administration-state.enum';

import { TableViewSessionModel } from './table-view-session-model';

/**
 * This service is just available to store data. TODO: This should be done in a store instead!
 */
@Injectable({
  providedIn: 'root',
})
export class TvaSessionStoreService {
  @observable
  private readonly mapTableViewSession = new Map<string, TableViewSessionModel>();

  public addTableViewSessionToMapTableViewSession(
    tableViewAreaEnum: TableViewAdministrationState,
    tableViewSessionObj: TableViewSessionModel,
  ): void {
    this.mapTableViewSession.set(tableViewAreaEnum, tableViewSessionObj);
  }

  public getTableViewSessionFromMapTableViewSessionByKey(tableViewAreaEnum: string): TableViewSessionModel {
    return this.mapTableViewSession.get(tableViewAreaEnum);
  }
}
